<template>
  <div class="searchbar">
    <div class="form-group">
      <div class="form-material pt-0">
        <input
          v-model="searchWord"
          type="text"
          class="input--search form-control"
          :placeholder="placeholder"
        />
        <span :style="{ 'background-color': primary }"></span>
        <img src="@/assets/media/icons/search.svg" alt="search icon" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Search module emits the following:
 * @property {Boolean} typing
 * @property {String} search
 */
import _ from "lodash";
export default {
  name: "SearchBar",
  props: {
    placeholder: {
      type: String,
      default: "Search"
    },
    searchTerm: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    searchWord: "",
    isTyping: false
  }),
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  watch: {
    searchWord: function() {
      this.$emit("typing", true);
      this.userTyping();
    }
  },
  created() {
    this.searchWord = this.searchTerm;
  },
  methods: {
    userTyping: _.debounce(function() {
      this.$emit("typing", false);
      this.$emit("search", this.searchWord);
    }, 300)
  }
};
</script>

<style lang="scss" scoped>
.searchbar {
  padding: 20px 0 0;
  .form-material {
    .input--search {
      border-bottom: 1px solid $gray-200;
      box-shadow: none;
      font-family: "Gotham Book", $headings-font-family;
      font-size: $font-size-sm;
      padding-left: 20px;
      padding-right: 20px;
      & + span {
        display: block;
        height: 2px;
        opacity: 0;
        transition: all 0.2s linear;
        width: 100%;
      }
      &:focus {
        & + span {
          opacity: 1;
        }
      }
    }

    img {
      height: 13px;
      left: 0;
      position: absolute;
      top: 11px;
      width: 13px;
    }
  }
}
</style>
